import React from 'react';
import { SettingsStore } from '@zen/common-app-parts';
import {
  CancelStore,
  IssueStore,
  RedeemStore,
  VerifyEventStore,
  VerifyAssetStore,
} from '../../../stores/FixedPayoutStore';

/**
 * a wrapper around the SettingsStore.Provider with the needed settings
 */
export default function Provider({ children }) {
  const {
    state: {
      settings: { nodeUrl },
    },
  } = SettingsStore.useStore();

  return (
    <IssueStore.Provider>
      <CancelStore.Provider>
        <VerifyEventStore.Provider>
          <VerifyAssetStore.Provider nodeUrl={nodeUrl}>
            <RedeemStore.Provider nodeUrl={nodeUrl}>{children}</RedeemStore.Provider>
          </VerifyAssetStore.Provider>
        </VerifyEventStore.Provider>
      </CancelStore.Provider>
    </IssueStore.Provider>
  );
}
